module.exports = __webpack_public_path__ + "static/img/gb.521ff917.svg";